import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../_services/auth.service';
import * as IMAGES from '../../assets/login-assets.json';

@Component({
    selector: 'app-viefy-change-email',
    templateUrl: './viefy-change-email.component.html',
    styleUrls: ['./viefy-change-email.component.css'],
    standalone: false
})
export class ViefyChangeEmailComponent implements OnInit {
  images: any = (IMAGES as any).default;
  constructor(
    private activatedRoute: ActivatedRoute,
    private vierfyService: AuthService
  ) {}
  icon: string = '';
  message: string = '';
  messagePassword: string = '';
  userId: string = '';
  code: string = '';
  email: string = '';
  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.email = params['email'];
      this.userId = params['userId'];
      this.code = params['code'];
    });
    this.vierfyService
      .vierfyAccountEmailChange(this.email, this.code, this.userId)
      .subscribe({
        next: () => {
          this.message = 'Your Email has been verified';
        },
        error: (error: any) => {
          this.message = error.error.InvalidToken;
        },
      });
  }
}
